import * as React from "react";
// Libraries component
import { Navigate, useLocation } from "react-router";
// Utilities
import { readToken } from "src/helpers/token";
import { rememberPostLoginRedirect } from "src/helpers/postLoginRedirect";
// Redux
import { useDispatch, useSelector } from "react-redux";
import UserActions from "src/store/User/user.actions";
import type { StateNetwork } from "src/store/index.reducer";
import type { UserState } from "src/store/User/user.reducer";
import { Loading } from "src/components/Loading";

export const PrivateRoute = (props) => {
	const { children } = props;
	const dispatch = useDispatch();
	const location = useLocation();
	const userStore = useSelector<StateNetwork, UserState>((state) => state.user);

	React.useEffect(() => {
		if (!userStore.guestBootstrapDone) {
			dispatch(UserActions.ensureGuestSession());
		}
	}, [dispatch, userStore.guestBootstrapDone]);

	if (!userStore.guestBootstrapDone) {
		return <Loading />;
	}

	if (readToken()) {
		return children;
	}

	rememberPostLoginRedirect(`${location.pathname}${location.search || ""}`);

	return <Navigate to="/authentication/login" />;
};
